import { Injectable } from '@angular/core';
import { Adapter } from '../../../../interfaces/Adapter';
import { UserGroup } from '../../../models/user/UserGroup';
import { UserGroupResponse } from '../../../../interfaces/response/UserResponses';

/**
 * An adapter converts user group HTTP response to domain object.
 */
@Injectable({
  providedIn: 'root'
})
export class UserGroupAdapter implements Adapter<UserGroup> {

  /**
   * Converts user group HTTP response to {@link UserGroup}.
   * @param item user group HTTP response.
   */
  adapt(item: UserGroupResponse): UserGroup {
    if (!item) {
      return null;
    }
    return new UserGroup(
      item.email,
      item.description,
      item.accessRules
    );
  }
}
